// extracted by mini-css-extract-plugin
export default {"fontFamily":"\"FS Me Web\"","darkRed":"#790031","midGray":"#737373","darkGrayTextColor":"#333","white":"#fff","zIndexMuiModal":"1300","zIndexMuiSnackbar":"1400"};